import React from 'react';
import { ButtonLink } from '../../../components';
import { t } from '../../../i18n';
import { formatCoursePrice } from '../../utilities';
import { cameraIcon, clockIcon } from '../../assets/index';
import classNames from 'classnames';
import UrlTo from '../../../url-to';
import PlayButton from '../play-button/index';
import './styles.scss';

const SingleCourseCard = ({ course, onPlayCoursePreview, isAvailableCourse }) => (
  <div className="centering-wrapper">
    <div className="single-course-card-wrapper">
      <h1 className={classNames(isAvailableCourse ? 'available-single-course-card-title' : 'single-course-card-title')}>
        {course.title}
      </h1>
      <div className="single-course-card">
        <div className="single-course-card__thumbnail" onClick={() => onPlayCoursePreview(course.previewVideo)}>
          <picture>
            <source media="(min-width: 1000px)" srcSet={course.previewImageUrlLarge} />
            <img src={course.previewImageUrlSmall} alt={course.title} className="single-course-card__thumbnail-image" />
          </picture>
          <PlayButton />
        </div>
        <div className="single-course-card__summary-and-description-wrapper">
          <h2>{course.author.fullName}</h2>
          <div className="single-course-card__summary-wrapper">
            <div className="single-course-card__course-hours">
              <img src={clockIcon} alt="hours" />
              <span className="single-course-card__course-hours_full">{`${course.hoursTotal} ${t(
                'DIGITAL_COURSES.HOURS',
              )}`}</span>
              <span className="single-course-card__course-hours_short">{`${course.hoursTotal}${t(
                'DIGITAL_COURSES.HOURS_SHORT',
              )}`}</span>
            </div>
            {course.lessonsTotal > 1 && (
              <div className="single-course-card__course-lessons-number">
                <img src={cameraIcon} alt="lessons-number" />
                {`${course.lessonsTotal} ${t('DIGITAL_COURSES.LESSONS')}`}
              </div>
            )}
            <div className="single-course-card__course-price">{formatCoursePrice(course.price)}</div>
          </div>
          <hr />
          <p className="single-course-card__description">{course.description}</p>
          <ButtonLink
            href={UrlTo.coursesSpecificCourse(course.id)}
            text={t('DIGITAL_COURSES.LEARN_MORE')}
            type="green"
            className="single-course-card__navigation-button"
          />
        </div>
      </div>
    </div>
  </div>
);

export default SingleCourseCard;
